<template>
	<div class="personalInformation ">
		<div class="wrapper1200">
			<div class="content">
				<div class="ohPublic">
					<img src="../assets/image/mainImage.png" alt="" />
				</div>
				<div class="personalNew flex">
					<div class="customerService flex">
						<img src="../assets/icon/telephone.png" alt=""
							style="width: 30px;height: 30px;margin-right: 10px;" />
						<div>联系客服：{{customerService.afterSale}}</div>
					</div>
					<div class="information flex">
						<!-- <img src="../assets/logo.png" alt="" v-if='information.avatar==null' /> -->
						<img :src="information.avatar" alt="" />
						<div>{{information.realName==null?'用户1234534':information.realName}}</div>
						<div @click="signOut">[退出]</div>
					</div>
				</div>
			</div>
			<div class="menu">
				<div class="singleMenu" :class="topush==item.url?'active':''" v-for="(item,index) in list" :key="index"
					@click="switchType(index,item)">
					{{item.name}}
				</div>
			</div>
		</div>
		<el-dialog title="请填写个人信息" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
			<div class="layoutContent">
				<div class="individualContent">
					<div class="title">姓名</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入您的姓名" v-model="realName" />
					</div>
				</div>
				<div class="individualContent">
					<div class="title">手机号(自愿)</div>
					<div class="inputBox">
						<input type="number" maxlength="11" placeholder="请输入您的手机号" v-model="phone" />
					</div>
				</div>
			</div>

			<div class="layoutContent">
				<div class="individualContent">
					<div class="title">性别</div>
					<div class="inputBox" style="display: flex;align-items: center;margin-left: 62px;">
						<div class="ualGoals">
							<img src="../assets/icon/choice.png" alt="" v-if="gender==0" />
							<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(0)" />
							<div>女</div>
						</div>
						<div class="ualGoals">
							<img src="../assets/icon/choice.png" alt="" v-if="gender==1" />
							<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(1)" />
							<div>男</div>
						</div>
					</div>
				</div>
				<div class="individualContent">
					<div class="title">年龄</div>
					<div class="inputBox" style="margin-left: 62px;">
						<el-date-picker v-model="birthday" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
							value-format="yyyy-MM-dd" @change="dateSelection">
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="layoutContent">
				<div class="individualContent">
					<div class="title">民族</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入您的民族" v-model="nation" />
					</div>
				</div>
				<div class="individualContent">
					<div class="title">地区</div>
					<div class="inputBox" style="margin-left: 62px;">
						<el-cascader style="width: 100%;" placeholder="省/市/区" v-model="values" :props="{value:'label'}"
							:options="options" @change="handleChange"></el-cascader>
						<!-- <cascader @provincesValueChang="provincesValueChang"
							:value="[form.province, form.city, form.area]" @update:value="form.region = $event"
							style="width: 100%"></cascader> -->
					</div>
				</div>
			</div>
			<div class="layoutContent">
				<div class="individualContent">
					<div class="title">新疆生活时间</div>
					<div class="inputBox" style="margin-left: 22px;">
						<el-time-picker arrow-control v-model="liveTime" placeholder="请选项新疆生活时间"
							@change='lifeTimeOperation' value-format='HH:mm'>
						</el-time-picker>
					</div>
				</div>

			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForReview">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		setContent,
		userInformation,
		realNameRegistration
	} from "@/api/api.js"

	import Vue from 'vue';
	import VueRouter from 'vue-router';
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		data() {
			return {
				options: regionData,
				dialogVisible: false,
				list: [{
					name: '首页',
					url: "/index/home"
				}, {
					name: '中医知识库',
					url: "/knowledgeBase"
				}, {
					name: '西北燥证诊断',
					url: "/drynessPathology"
				}, {
					name: '饮食指导',
					url: "/dietaryGuidance"
				}, {
					name: '病例信息',
					url: "/caseInformation"
				}, {
					name: '个人信息',
					url: "/personalInformation"
				}],
				single: 0,
				customerService: '',
				information: '',
				topush: '',
				values: '',


				gender: 0,
				realName: "",
				phone: '',
				address: '',
				nation: '',
				liveTime: '',
				birthday: '',
			}
		},
		mounted() {},
		created() {
			this.setUp()
			if (localStorage.getItem('token')) {
				this.personalInformation()
			} else {
				this.$router.push({
					path: '/login'
				})
			}
			this.topush = sessionStorage.getItem('index')
			console.log(this.topush, '123123')

		},
		watch: {
			'$route'(to, from) {
				this.topush = to.path
				if (to.path == '/addCase' || to.path == '/caseDetails') {
					this.topush = '/caseInformation'
				}
				console.log('路由变化了:', from.path, '->', to.path);
			}
		},
		methods: {
			submitForReview() {
				if (this.realName == '') {
					this.$message.error('请输入姓名');
					return
				}
				// if (this.phone == '') {
				// 	this.$message.error('请输入手机号');
				// 	return
				// }
				if (this.birthday == '') {
					this.$message.error('请选择出生日期');
					return
				}
				if (this.nation == '') {
					this.$message.error('请输入民族');
					return
				}
				if (this.address == '') {
					this.$message.error('请选择省市区');
					return
				}
				if (this.liveTime == '') {
					this.$message.error('请选择新疆生活时间');
					return
				}

				realNameRegistration({
					realName: this.realName,
					phone: this.phone,
					address: this.address,
					gender: this.gender,
					birthday: this.birthday,
					nation: this.nation,
					liveTime: this.liveTime,
					isReal: 1
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						var add = {
							realName: this.realName,
							phone: this.phone,
							address: this.address,
							gender: this.gender,
							birthday: this.birthday,
							nation: this.nation,
							liveTime: this.liveTime,
						}
						localStorage.setItem('storeContent', JSON.stringify(add))
						setTimeout(() => {
							this.dialogVisible = false
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			//日期选择
			dateSelection(e) {
				this.birthday = e
				console.log(e)
			},
			// 省市区
			handleChange(value) {
				this.address = value[0] + value[1] + value[2]
				this.values = value
				console.log(value)
			},
			// 性别
			genderSwitching(i) {
				this.gender = i
			},
			lifeTimeOperation(e) {
				this.liveTime = e
				console.log(e)
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			//退出登录
			signOut() {
				this.$confirm('是否退出当前账号?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					localStorage.removeItem('token')
					sessionStorage.setItem('index', '/index/home')
					this.$message({
						type: 'success',
						message: '退出成功!'
					});
					setTimeout(() => {
						this.$router.push({
							path: '/login'
						})
					}, 1000);
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			// 用户信息
			personalInformation() {
				userInformation().then(res => {
					// console.log(res, '123123')
					if (res.code == 200) {
						if (res.data.isReal == 0) {
							this.dialogVisible = true
						}
						this.information = res.data
					}
				})
			},
			//客服信息
			setUp() {
				setContent({
					groupKey: "kf"
				}).then(res => {
					this.customerService = res.data
				})

			},
			switchType(index, item) {
				this.single = index
				sessionStorage.setItem('index', item.url)
				this.$router.push({
					path: item.url
					// query: {
					// 	id: '123'
					// }
				}).catch(() => {})
			}
		}
	}
</script>
<style>
	body {
		background: #FFFCF6;
	}
</style>
<style lang="scss" scoped>
	.layoutContent {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;

		.individualContent {
			width: 45%;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #E6E6E6;

			.title {
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #333333;
			}

			.inputBox {
				padding-top: 20px;
				padding-bottom: 20px;

				.ualGoals {
					display: flex;
					align-items: center;
					margin-right: 40px;

					img {
						margin-right: 10px;
						width: 15px;
						height: 15px;
					}
				}

				input {
					border: none;
					outline: none;
					box-shadow: none;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333;
					margin-left: 62px;
				}
			}
		}
	}

	.personalInformation {
		background: #ffffff;
		cursor: default;

		.content {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 10px 0;

			.ohPublic {
				width: 102px;
				height: 46px;

				img {
					width: 102px;
					height: 46px;
				}
			}

			.customerService {
				margin-right: 41px;
			}

			.personalNew {
				display: flex;
				align-items: center;

				.information {
					div:nth-of-type(1) {
						font-family: PingFang SC, PingFang SC;
						font-weight: bold;
						font-size: 18px;
						color: #333333;
						margin: 0 10px;
					}

					div:nth-of-type(2) {
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 18px;
						color: #666666;
					}

					img {
						width: 30px;
						height: 30px;
						border-radius: 100%;
					}
				}
			}
		}

	}

	.menu {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 0;
		background: #ffffff;

		.singleMenu {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
			width: 120px;
			text-align: center;
			cursor: default;
		}

		.active {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 18px;
			color: #533820;
			position: relative;
		}

		.active::after {
			content: "";
			position: absolute;
			width: 48px;
			height: 5px;
			background: #937154;
			opacity: 1;
			left: 0;
			right: 0;
			bottom: 0;
			top: 45px;
			margin: auto;
		}
	}
</style>